'use client';

import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme="light"
            className="toaster group z-[999999] !font-[inherit]"
            position="top-center"
            dir="rtl"
            richColors
            visibleToasts={1}
            toastOptions={{
                classNames: {
                    toast: 'group toast group-[.toaster]:text-sm group-[.toaster]:rounded-[20px]'
                }
            }}
            {...props}
        />
    );
};

export { Toaster };
